import { useCallback } from 'react';
import type { FindEdgesValue } from '../../lib/filters/find-edges';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Find Edges panel — single sensitivity slider. */
export function FindEdgesPanel({ value, onChange }: AdjustmentPanelProps<FindEdgesValue>) {
  const set = useCallback(
    (patch: Partial<FindEdgesValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Sensitivity"
        min={0}
        max={200}
        step={1}
        value={value.amount}
        onChange={(v) => set({ amount: v })}
      />
    </div>
  );
}
